import {itemWithoutCombinedListingWithoutAdditionalRibbons} from './itemWithoutCombinedListingWithoutAdditionalRibbons';

export const query = `query getFilteredProductsWithoutCombinedListingWithoutAdditionalRibbons($mainCollectionId: String!, $filters: ProductFilters, $sort: ProductSort, $offset: Int, $limit: Int, $withOptions: Boolean = false, $withPriceRange: Boolean = false) {
  catalog {
    category(categoryId: $mainCollectionId) {
      productsWithMetaData(filters: $filters, limit: $limit, sort: $sort, offset: $offset, onlyVisible: true) {
        totalCount
        list {
           ${itemWithoutCombinedListingWithoutAdditionalRibbons}
        }
      }
    }
  }
}
`;
